import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoadingAnimationService {
    protected subscriptions: Subscription[] = [];
    protected promises: Promise<any>[] = [];
    protected runningLoadingAnimationSubscription: Subscription | undefined;
    protected unfullfilledLoadingAnimationPromise: Promise<any> | undefined;
    protected hideState: boolean = true;

    constructor(public service: NgxSpinnerService) {
        //
    }

    public showSpinnerUsingPromise(promise: Promise<any>): void {
        const self = this;
        self.promises.push(promise)

        self.service.show();

        if(!self.unfullfilledLoadingAnimationPromise && !self.runningLoadingAnimationSubscription){
            self.unfullfilledLoadingAnimationPromise = self.promises.shift();
            self.unfullfilledLoadingAnimationPromise?.then(() => {
                self.onTeardown();
            });
        }
    }

    public showSpinnerUsingSubscription(subscription: Subscription): void {
        const self = this;
        self.subscriptions.push(subscription);

        self.service.show();

        if(!self.unfullfilledLoadingAnimationPromise && !self.runningLoadingAnimationSubscription){
            self.runningLoadingAnimationSubscription = self.subscriptions.shift();
            self.runningLoadingAnimationSubscription?.add(() => {
                self.onTeardown();
            });
        }
    }

    public donNotHide(): this {
        this.hideState = false;
        return this;
    }

    public hide(): this {
        this.hideState = true;
        return this;
    }

    public onTeardown() : void {
        this.runningLoadingAnimationSubscription = undefined;
        this.unfullfilledLoadingAnimationPromise = undefined;

        let openSubscription: Subscription | undefined = this.subscriptions.shift();

        if(openSubscription != undefined){
            openSubscription.add(this.onTeardown());
            return;
        }

        let unfulfilledPromise: Promise<any> | undefined = this.promises.shift();

        if(unfulfilledPromise != undefined){
            unfulfilledPromise.then(() => this.onTeardown());
            return;
        }

        // if true, then the loader will disappear
        // otherwise it will be set to default
        if (this.hideState) {
            this.service.hide();
        } else {
            this.hideState = true;
        }
    }
}